'use client';

import { c as _c } from "react/compiler-runtime";
import { isAdSlotPosition } from '@/utils/adSlotPosition';
import { NativeAdSlot } from './NativeAdSlot';
import { SEARCH_AD_PLACEMENTS, type SearchAdPlacement } from './searchAdPlacements';
interface SearchCategoryAdSlotProps {
  placement: SearchAdPlacement;
  position: number;
  listLength: number;
  as?: 'div' | 'li';
  className?: string;
}
export const SearchCategoryAdSlot = t0 => {
  const $ = _c(4);
  const {
    placement,
    position,
    listLength,
    as: t1,
    className
  } = t0;
  const as = t1 === undefined ? "div" : t1;
  const config = SEARCH_AD_PLACEMENTS[placement];
  const show = isAdSlotPosition(position, listLength, config.positionRule);
  if (!show) {
    return null;
  }
  let t2;
  if ($[0] !== as || $[1] !== className || $[2] !== config.nativeSlot) {
    t2 = <NativeAdSlot {...config.nativeSlot} as={as} className={className} />;
    $[0] = as;
    $[1] = className;
    $[2] = config.nativeSlot;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};